/*!
   * PatternFly Elements: PfeInput 2.6.6
   * @license
   * Copyright 2020 Red Hat, Inc.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 * 
*/

import PFElement from '../../pfelement-onhighway/dist/pfelement.umd';

export function parseFunction(fn) {
  try {
    if (typeof fn === 'string') {
      return new Function(`return ${fn}`)();
    } else if (typeof fn === 'function') {
      return fn;
    } else {
      return new Function();
    }
  } catch (e) {
    return null;
  }
}

class PfeInput extends PFElement {
    static get version() {
      return "2.6.6";
    }
  
    get html() {
      return `<style>:host{--pfe-input--HorizontalSpacing:13px;--pfe-input--Width:100%;--pfe-input--BorderStyle:var(--pfe-theme--ui--border-style, solid);--pfe-input--BorderWidth:var(--pfe-theme--ui--border-width, 2px);--pfe-input--BorderRadius:var(--pfe-theme--ui--border-radius, 8px);--pfe-input--BorderColor:transparent;--pfe-input--BackgroundColor:var(--pfe-theme--color--ui-base, #fff);--pfe-input--BackgroundColor--disabled:var(--pfe-theme--color--ui-disabled, #d0d0d0);--pfe-input__validation-text--FontWeight:bold;--pfe-input--BoxShadow:0 9px 10px rgba(0, 0, 0, 0.1);display:inline-block;width:var(--pfe-input--Width)}:host,:host *{-webkit-box-sizing:content-box;box-sizing:content-box}:host .wrapper{-webkit-box-shadow:var(--pfe-input--BoxShadow);box-shadow:var(--pfe-input--BoxShadow);display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;height:50px;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;border-style:var(--pfe-input--BorderStyle);border-width:var(--pfe-input--BorderWidth);border-radius:var(--pfe-input--BorderRadius);border-color:var(--pfe-input--BorderColor);padding:0 var(--pfe-input--HorizontalSpacing);background-color:var(--pfe-input--BackgroundColor)}:host .wrapper ::slotted([slot^=icon]){-webkit-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0;--pfe-icon--Color:var(--pfe-theme--color--ui-base--text, #004b93)}:host .wrapper ::slotted([slot=icon-left]),:host .wrapper ::slotted([slot=icon-start]){margin-right:var(--pfe-input--HorizontalSpacing)}:host .wrapper ::slotted([slot=icon-end]),:host .wrapper ::slotted([slot=icon-right]){margin-left:var(--pfe-input--HorizontalSpacing)}:host .inner-wrapper{position:relative;width:100%;-webkit-box-flex:1;-webkit-flex-grow:1;-ms-flex-positive:1;flex-grow:1}:host .inner-wrapper ::slotted([slot=label]){display:block;font-size:14px;font-weight:700;width:100%;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;color:#1e1e1d;color:var(--pfe-theme--color--text,#1e1e1d)}:host input{display:block;-webkit-appearance:none;-moz-appearance:none;appearance:none;border:none;background-color:transparent;font-size:14px;color:#1e1e1d;color:var(--pfe-theme--color--text,#1e1e1d);width:100%;padding:0}:host input:focus{-webkit-appearance:none;-moz-appearance:none;appearance:none;outline:0}:host ::slotted([slot=validation-text]){display:none;text-align:right;font-size:12px;font-weight:var(--pfe-input__validation-text--FontWeight)}:host(:not([disabled])),:host([disabled=false]){cursor:text}:host([hidden]){display:none}:host([active=true]) .inner-wrapper ::slotted([slot=label]){color:#004b93;color:var(--pfe-theme--color--ui-base--text,#004b93)}:host([active=true]) .wrapper{border-color:#004b93;border-color:var(--pfe-theme--color--ui-complement,#004b93)}:host([pfe-status=error]:not([disabled=true])) ::slotted([slot=validation-text]),:host([pfe-status=error][disabled=false]) ::slotted([slot=validation-text]),:host([pfe-status=success]:not([disabled])) ::slotted([slot=validation-text]),:host([pfe-status=success][disabled=false]) ::slotted([slot=validation-text]){display:block}:host([pfe-status=success]:not([disabled])) .inner-wrapper ::slotted([slot=label]),:host([pfe-status=success]:not([disabled])[active]) .inner-wrapper ::slotted([slot=label]),:host([pfe-status=success][disabled=false]) .inner-wrapper ::slotted([slot=label]),:host([pfe-status=success][disabled=false][active]) .inner-wrapper ::slotted([slot=label]){color:#40ab00;color:var(--pfe-theme--color--feedback--success,#40ab00)}:host([pfe-status=success]:not([disabled])) .wrapper,:host([pfe-status=success]:not([disabled])[active]) .wrapper,:host([pfe-status=success][disabled=false]) .wrapper,:host([pfe-status=success][disabled=false][active]) .wrapper{border-color:#40ab00;border-color:var(--pfe-theme--color--feedback--success,#40ab00)}:host([pfe-status=success]:not([disabled])) .wrapper ::slotted(pfe-icon),:host([pfe-status=success]:not([disabled])[active]) .wrapper ::slotted(pfe-icon),:host([pfe-status=success][disabled=false]) .wrapper ::slotted(pfe-icon),:host([pfe-status=success][disabled=false][active]) .wrapper ::slotted(pfe-icon){--pfe-icon--Color:var(--pfe-theme--color--feedback--success, #40ab00)}:host([pfe-status=success]:not([disabled])) ::slotted([slot=validation-text]),:host([pfe-status=success]:not([disabled])[active]) ::slotted([slot=validation-text]),:host([pfe-status=success][disabled=false]) ::slotted([slot=validation-text]),:host([pfe-status=success][disabled=false][active]) ::slotted([slot=validation-text]){color:#40ab00;color:var(--pfe-theme--color--feedback--success,#40ab00)}:host([pfe-status=error]:not([disabled])) .inner-wrapper ::slotted([slot=label]),:host([pfe-status=error]:not([disabled])[active]) .inner-wrapper ::slotted([slot=label]),:host([pfe-status=error][disabled=false]) .inner-wrapper ::slotted([slot=label]),:host([pfe-status=error][disabled=false][active]) .inner-wrapper ::slotted([slot=label]){color:#c71515;color:var(--pfe-theme--color--feedback--critical,#c71515)}:host([pfe-status=error]:not([disabled])) .wrapper,:host([pfe-status=error]:not([disabled])[active]) .wrapper,:host([pfe-status=error][disabled=false]) .wrapper,:host([pfe-status=error][disabled=false][active]) .wrapper{border-color:#c71515;border-color:var(--pfe-theme--color--feedback--critical,#c71515)}:host([pfe-status=error]:not([disabled])) .wrapper ::slotted(pfe-icon),:host([pfe-status=error]:not([disabled])[active]) .wrapper ::slotted(pfe-icon),:host([pfe-status=error][disabled=false]) .wrapper ::slotted(pfe-icon),:host([pfe-status=error][disabled=false][active]) .wrapper ::slotted(pfe-icon){--pfe-icon--Color:var(--pfe-theme--color--feedback--critical, #c71515)}:host([pfe-status=error]:not([disabled])) ::slotted([slot=validation-text]),:host([pfe-status=error]:not([disabled])[active]) ::slotted([slot=validation-text]),:host([pfe-status=error][disabled=false]) ::slotted([slot=validation-text]),:host([pfe-status=error][disabled=false][active]) ::slotted([slot=validation-text]){color:#c71515;color:var(--pfe-theme--color--feedback--critical,#c71515)}:host([disabled]:not([disabled=false])) .inner-wrapper ::slotted([slot=label]),:host([disabled]:not([disabled=false])[active]) .inner-wrapper ::slotted([slot=label]){color:#a2a2a2;color:var(--pfe-theme--color--ui-disabled--text,#a2a2a2)}:host([disabled]:not([disabled=false])) .wrapper,:host([disabled]:not([disabled=false])[active]) .wrapper{background-color:var(--pfe-input--BackgroundColor--disabled)}:host([disabled]:not([disabled=false])) .wrapper ::slotted(pfe-icon),:host([disabled]:not([disabled=false])[active]) .wrapper ::slotted(pfe-icon){--pfe-icon--Color:var(--pfe-theme--color--ui-disabled--text, #a2a2a2)}:host([disabled]:not([disabled=false])) input::-webkit-input-placeholder,:host([disabled]:not([disabled=false])[active]) input::-webkit-input-placeholder{color:#a2a2a2;color:var(--pfe-theme--color--ui-disabled--text,#a2a2a2)}:host([disabled]:not([disabled=false])) input::-moz-placeholder,:host([disabled]:not([disabled=false])[active]) input::-moz-placeholder{color:#a2a2a2;color:var(--pfe-theme--color--ui-disabled--text,#a2a2a2)}:host([disabled]:not([disabled=false])) input:-ms-input-placeholder,:host([disabled]:not([disabled=false])[active]) input:-ms-input-placeholder{color:#a2a2a2;color:var(--pfe-theme--color--ui-disabled--text,#a2a2a2)}:host([disabled]:not([disabled=false])) input::-ms-input-placeholder,:host([disabled]:not([disabled=false])[active]) input::-ms-input-placeholder{color:#a2a2a2;color:var(--pfe-theme--color--ui-disabled--text,#a2a2a2)}:host([disabled]:not([disabled=false])) input::placeholder,:host([disabled]:not([disabled=false])[active]) input::placeholder{color:#a2a2a2;color:var(--pfe-theme--color--ui-disabled--text,#a2a2a2)}:host([variant=minimal]){--pfe-input--BoxShadow:none}:host([variant=minimal]) .wrapper{background-color:transparent;border-width:0;border-radius:0;border-bottom-width:1px;border-bottom-color:#7f7366;padding:calc(var(--pfe-input--HorizontalSpacing) + 2px);padding:calc(var(--pfe-input--HorizontalSpacing) + var(--pfe-theme--ui--border-width,2px));padding-top:2px;padding-top:var(--pfe-theme--ui--border-width,2px);padding-bottom:calc(2px - 1px);padding-bottom:calc(var(--pfe-theme--ui--border-width,2px) - 1px)}:host([variant=minimal]) .wrapper ::slotted(pfe-icon){--pfe-icon--Color:#7f7366}:host([variant=minimal]) ::slotted([slot=validation-text]){font-weight:400}:host([variant=minimal][active]:not([active=false]):not([pfe-status])) .wrapper{border-bottom-color:#004b93;border-bottom-color:var(--pfe-theme--color--ui-base--text,#004b93)}:host([variant=minimal][active]:not([active=false]):not([pfe-status])) .wrapper ::slotted(pfe-icon){--pfe-icon--Color:var(--pfe-theme--color--ui-base--text, #004b93)}:host([variant=minimal][disabled]:not([disabled=false])) .wrapper{background-color:transparent}:host([variant=with-border]){--pfe-input--BorderColor:var(--pfe-theme--color--surface--border--lightest, #d0d0d0)}:host([dir=rtl]) .wrapper ::slotted([slot=icon-left]),:host([dir=rtl]) .wrapper ::slotted([slot=icon-start]){margin-left:var(--pfe-input--HorizontalSpacing);margin-right:0}:host([dir=rtl]) .wrapper ::slotted([slot=icon-end]),:host([dir=rtl]) .wrapper ::slotted([slot=icon-right]){margin-right:var(--pfe-input--HorizontalSpacing);margin-left:0}:host([dir=rtl]) ::slotted([slot=validation-text]){text-align:left}
/*# sourceMappingURL=pfe-input.min.css.map */
</style><div class="wrapper">
  <slot name="icon-left"></slot>
  <slot name="icon-start"></slot>
  <div class="inner-wrapper">
    <slot name="label"></slot>
    <input id="input"/>
  </div>
  <slot name="icon-right"></slot>
  <slot name="icon-end"></slot>
</div>
<slot name="validation-text"></slot>`;
    }
  
    static get properties() {
      return {"has-name":{"title":"Input's name","type":"string","default":"Username","prefixed":false},"is-disabled":{"title":"Is disabled","type":"boolean","default":false,"prefixed":false},"has-placeholder":{"title":"Placeholder text","type":"string","default":"Type your username","prefixed":false},"has-value":{"title":"Input's default value","type":"string","default":"","prefixed":false},"on_blur":{"title":"Callback to call on input blur","type":"string","enum":["console.log","alert"],"default":false,"prefixed":false},"on_input":{"title":"Callback to call on input change","type":"string","enum":["console.log","alert"],"default":false,"prefixed":false}};
    }
  
    static get slots() {
      return {"label":{"title":"Label text","type":"string","namedSlot":true,"default":"*Label"},"validation-text":{"title":"Validation text","type":"string","namedSlot":true,"default":"Validation text"}};
    }
  static get tag() {
    return 'pfe-input';
  }

  get schemaUrl() {
    return 'pfe-input.json';
  }

  get templateUrl() {
    return 'pfe-input.html';
  }

  get styleUrl() {
    return 'pfe-input.scss';
  }

  static get PfeType() {
    return PFElement.PfeTypes.Content;
  }

  static get propsAndAttrs() {
    return [
      ...super.propsAndAttrs,
      new this.propsAndAttrsAPI.string('variant', 'variant', (instance, oldVal, newVal) => {
        instance.updatesStylesForIE();
      }),

      // this special case of different behaviour from standard disabled of input
      // it is made for support of deprecated [attr.disabled]="variable" angular directive
      new this.propsAndAttrsAPI.boolean('disabled', 'disabled', (instance) => {
        instance.input.disabled = instance.disabled;
        instance.updatesStylesForIE();
      }),
    ];
  }

  get input() {
    return this.shadowRoot.querySelector('input');
  }

  // supported input attributes
  static get inputAttributes() {
    return ['maxlength', 'name', 'placeholder', 'type', 'value'];
  }

  static getinputRelatedProperty(inputAttributeName) {
    switch (inputAttributeName) {
      case 'maxlength':
        return 'maxLength';
      case 'value':
        console.warn("'value' attribute and property are different in standard input");
        return;
      default:
        return inputAttributeName;
    }
  }

  static get analyticsEvents() {
    return ['blur', 'focus', 'input'];
  }

  // =============================================================================
  // input attributes getters and setters, to emulate standard input functionality
  // =============================================================================

  _standardInputSetterProcessing(attrName, newVal) {
    const propertyName = PfeInput.getinputRelatedProperty(attrName);
    this.input[propertyName] = newVal;
    if (this.input.hasAttribute(attrName)) {
      this.setAttribute(attrName, this.input.getAttribute(attrName));
    } else {
      this.removeAttribute(attrName);
    }
  }

  get type() {
    return this.input.type;
  }

  set type(newVal) {
    this._standardInputSetterProcessing('type', newVal);
  }

  get maxLength() {
    return this.input.maxLength;
  }

  set maxLength(newVal) {
    this._standardInputSetterProcessing('maxlength', newVal);
  }

  get name() {
    return this.input.name;
  }

  set name(newVal) {
    this._standardInputSetterProcessing('name', newVal);
  }

  get placeholder() {
    return this.input.placeholder;
  }

  set placeholder(newVal) {
    this._standardInputSetterProcessing('placeholder', newVal);
  }

  // add here other getter and setter for input properties, like the ones above

  // =============================================================================
  // anomalous getters and setters

  // get disabled() {
  //   return this.input.disabled;
  // }
  //
  // set disabled(newVal) {
  //   if (newVal) {
  //     this.setAttribute("disabled", "true");
  //   } else {
  //     this.removeAttribute("disabled");
  //   }
  // }

  get value() {
    return this.input.value;
  }

  set value(newVal) {
    if (typeof newVal != 'undefined') {
      this.input.value = newVal;
    }
  }

  // no getter for startValue, as the value attr of the input could be later changed
  set startValue(value) {
    if (value == null || typeof value == 'undefined') {
      this.removeAttribute('value');
    } else {
      this.setAttribute('value', value);
    }
  }

  // =============================================================================

  get changeCallback() {
    if (this._changeCallback) {
      return this._changeCallback;
    }
    const changeCallbackFn = parseFunction(this.getAttribute('change-callback'));
    this._changeCallback = changeCallbackFn;
    return changeCallbackFn;
  }

  set changeCallback(newVal) {
    if (!this._changeCallback && newVal) {
      this._changeCallback = newVal;
      this.setAttribute('change-callback', newVal);
    }
  }

  get blurCallback() {
    if (this._blurCallback) {
      return this._blurCallback;
    }
    const blurCallbackFn = parseFunction(this.getAttribute('blur-callback'));
    this._blurCallback = blurCallbackFn;
    return blurCallbackFn;
  }

  set blurCallback(newVal) {
    if (!this._blurCallback && newVal) {
      this._blurCallback = newVal;
      this.setAttribute('blur-callback', newVal);
    }
  }

  get onBlur() {
    return this.hasAttribute('blur-callback');
  }

  get onInput() {
    return this.hasAttribute('change-callback');
  }

  get active() {
    return this.hasAttribute('active') && this.getAttribute('active') === 'true';
  }

  set active(newVal) {
    if (newVal) {
      this.setAttribute('active', 'true');
    } else {
      this.removeAttribute('active');
    }
  }

  handleClick() {
    this.input.focus();
  }

  handleInputFocus(originalEvent) {
    this.active = true;
    this.analyticsLog('focus', {
      originalEvent,
      originalTarget: originalEvent.target,
      value: this.value,
    });
  }

  handleInputChange(originalEvent) {
    const value = this.value;
    if (this.changeCallback) {
      this.changeCallback({ name: this.name, value });
    }
    this.analyticsLog('input', {
      originalEvent,
      originalTarget: originalEvent.target,
    });
  }

  handleInputBlur(originalEvent) {
    this.active = false;
    this.analyticsLog('blur', {
      originalEvent,
      originalTarget: originalEvent.target,
    });
    const value = this.value;
    if (this.blurCallback) {
      this.blurCallback({ name: this.name, value });
    }
  }

  constructor() {
    super(PfeInput, { type: PfeInput.PfeType });
    this.initListeners();
  }

  static get observedAttributes() {
    return PfeInput.inputAttributes.concat(['change-callback', 'blur-callback', 'max-length', 'pfe-status'], super.observedAttributes);
  }

  attributeChangedCallback(attr, oldVal, newVal) {
    super.attributeChangedCallback(attr, oldVal, newVal);

    if (PfeInput.inputAttributes.some((inputAttr) => inputAttr === attr)) {
      if (newVal != null) {
        this.input.setAttribute(attr, newVal);
      } else {
        this.input.removeAttribute(attr);
      }
    } else if (this.constructor.propAndAttrsObservedAttributes.every((element) => element !== attr)) {
      if (attr === 'max-length') {
        if (newVal != null) {
          this.setAttribute('maxlength', newVal);
        } else {
          this.removeAttribute('maxlength');
        }
      }
      if (oldVal !== newVal) {
        this[attr] = this[attr];
      }
    }
  }

  initListeners() {
    this.handleClick = this.handleClick.bind(this);
    this.handleInputFocus = this.handleInputFocus.bind(this);
    this.handleInputBlur = this.handleInputBlur.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);

    this.addEventListener('click', this.handleClick);

    // these events will not trigger if the input is disabled
    this.input.addEventListener('focus', this.handleInputFocus);
    this.input.addEventListener('blur', this.handleInputBlur);
    this.input.addEventListener('input', this.handleInputChange);
  }

  setInputMaxLength(newVal) {
    this.maxLength = newVal;
  }

  // ==========================================================
  // Section to be moved to the pfelement
  // ==========================================================

  _mapSchemaToProperties(tag, properties) {
    // this prevents the mapping done in pfelement which needs to be deprecated
  }

  updatesStylesForIE() {
    if (window.ShadyCSS && window.ShadyCSS.styleSubtree) {
      window.ShadyCSS.styleSubtree(this);
    }
  }
  // ==========================================================
}

PFElement.create(PfeInput);

export default PfeInput;
